import React, { Fragment, useEffect, useState } from "react";
import {
  CardHeader,
  Col,
  Button,
  Row,
  Form,
  Label,
  Input,
  FormGroup,
} from "reactstrap";
import { H1, H5 } from "../../../AbstractElements";
import { formatRP } from "../../../Utils/externalFunctions";
import DataTable from "react-data-table-component";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import { convertRPInputToIntValue } from "../../../Utils/otherFunctions";
import FilterComponent from "../../FilterComponents/FilterComponent";
import { useThemeContext } from "../../../Context/ThemeContext";
import { filterSearch } from "../../../Utils/FilterItems";

const StepTiga = ({
  prevStep,
  nextStep,
  handleInputChange,
  total,
  formRealokasi,
  unitKerja,
  rencImp,
  anggaranRencimpFormattedNilai,
  setAnggaranRencimpFormattedNilai,
}) => {
  const [isNextDisable, setIsNextDisable] = useState(true);
  const [totalColor, setTotalColor] = useState("txt-danger");
  const [filterText, setFilterText] = useState("");
  const [selectedUnitKerja, setSelectedUnitKerja] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const { themeContext } = useThemeContext();

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const filterItems = (items) => {
    const searchCategories = [
      "nm_org",
      "kd_org",
      "nm_keg",
      "kd_keg",
      "nm_akun",
      "kd_akun",
      "anggaran_tersisa",
    ];
    const filteredItems = items
      .filter(filterSearch(searchCategories, filterText))
      .filter(filterSearch(["nm_org"], selectedUnitKerja));

    return filteredItems;
  };

  const sumberDanaLookup = {
    51: "51 - BP",
    61: "61 - Non BP",
    81: "81 - Dana Khusus",
  };

  const checkNextButton = (
    formRealokasi,
    total,
    anggaranRencimpFormattedNilai
  ) => {
    const nilaiAnggaran = parseInt(formRealokasi.nilai_anggaran);
    setIsNextDisable(
      nilaiAnggaran !== total ||
        anggaranRencimpFormattedNilai.filter((data) => !data.isValid).length > 0
    );
    toggleTotalColor(nilaiAnggaran === total);
  };
  useEffect(() => {
    checkNextButton(formRealokasi, total, anggaranRencimpFormattedNilai);
  }, [formRealokasi, total, anggaranRencimpFormattedNilai]);

  useEffect(() => {
    filterItems(rencImp)?.forEach((data) => {
      const selectedAnggaran = getRencanaimpFormattedNilai(data);
      if (selectedAnggaran) {
        checkIsJumlahValid({
          target: {
            id: data.pk,
            value: selectedAnggaran.formatted_nilai,
          },
        });
      }
    });
  }, []);

  const toggleTotalColor = (isSuccess) => {
    setTotalColor(isSuccess ? "txt-success" : "txt-danger");
  };

  const getRencanaimpFormattedNilai = (row) => {
    if (anggaranRencimpFormattedNilai) {
      const existingObject = anggaranRencimpFormattedNilai.find(
        (item) => item.pk === row.pk
      );
      return existingObject ? existingObject : null;
    } else return null;
  };

  const checkIsJumlahValid = (e) => {
    const { id, value } = e.target;

    const numericValue = convertRPInputToIntValue(value);

    const rencImpItem = rencImp.find((item) => item.pk === parseInt(id));

    const jumlahIsValid =
      parseFloat(numericValue) <=
      parseFloat(convertRPInputToIntValue(rencImpItem.anggaran_tersisa));

    setAnggaranRencimpFormattedNilai((prev) => {
      return prev.map((item) => {
        if (item.pk === parseInt(id)) {
          return {
            ...item,
            isValid: formRealokasi.is_target === "t" ? true : jumlahIsValid,
          };
        } else {
          return item;
        }
      });
    });
  };

  const daftarRencImpColumns = [
    {
      name: <DataTableTitle text={"DPSJ"} />,
      selector: (row) => row.nm_org,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Sumber Dana"} />,
      selector: (row) =>
        sumberDanaLookup[row.id_sumber_dana]
          ? sumberDanaLookup[row.id_sumber_dana]
          : row.id_sumber_dana,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Kegiatan"} />,
      selector: (row) => row.kd_keg + "-" + row.nm_keg,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Akun"} />,
      selector: (row) => row.kd_akun + "-" + row.nm_akun,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Sisa Anggaran (Rp)"} />,
      selector: (row) => parseInt(row.anggaran_tersisa),
      sortable: true,
      format: (row) => formatRP(row.anggaran_tersisa),
    },
    {
      name: <DataTableTitle text={"Jumlah"} />,
      cell: (row) => {
        const selectedAnggaran = getRencanaimpFormattedNilai(row);
        return (
          <FormGroup>
            <Col>
              {selectedAnggaran ? (
                <Input
                  id={row.pk}
                  name="formDataAnggaranUMK"
                  data-field-type="anggaran_digunakan"
                  onChange={(e) => {
                    handleInputChange(e);
                    checkIsJumlahValid(e, selectedAnggaran);
                  }}
                  value={selectedAnggaran.formatted_nilai}
                  invalid={!selectedAnggaran.isValid}
                />
              ) : (
                <Input
                  id={row.pk}
                  name="formDataAnggaranUMK"
                  data-field-type="anggaran_digunakan"
                  onChange={(e) => {
                    handleInputChange(e);
                    checkIsJumlahValid(e, selectedAnggaran);
                  }}
                />
              )}
            </Col>
          </FormGroup>
        );
      },
    },
  ];

  return (
    <Fragment>
      <Row>
        <Col sm="12">
          <Form className="needs-validation" noValidate>
            <Row>
              <Col sm="12">
                <Col sm="12" className="text-center mb-4 mt-4">
                  <Label className="txt-success">Dana yang dibutuhkan</Label>
                  <div className={`text-center ${totalColor}`}>
                    <H1>
                      Rp. {formatRP(total)} /{" "}
                      {formatRP(formRealokasi.nilai_anggaran)}
                    </H1>
                  </div>
                </Col>
                <CardHeader className="pb-0 text-center">
                  <H5>Daftar Sumber Dana yang Dapat Digunakan</H5>
                </CardHeader>

                <CardHeader className="row align-items-center pb-0">
                  <strong className="col-2">DPSJ</strong>
                  <select
                    aria-label="unitkerja"
                    name="id_unit_kerja"
                    className="form-control form-select w-100 col"
                    defaultValue={""}
                    onChange={(e) => setSelectedUnitKerja(e.target.value)}
                  >
                    <option value={""}>Semua</option>
                    {unitKerja.map((unitKerja) => (
                      <option key={unitKerja.pk}>
                        {unitKerja.nama_unit_kerja}
                      </option>
                    ))}
                  </select>
                </CardHeader>
                <CardHeader></CardHeader>

                <DataTable
                  columns={daftarRencImpColumns}
                  data={filterItems(rencImp)}
                  pagination
                  selectableRowsHighlight
                  highlightOnHover
                  persistTableHead
                  subHeader
                  subHeaderComponent={
                    <FilterComponent
                      onFilter={(e) => {
                        setFilterText(e.target.value);
                      }}
                      onClear={() => handleClear()}
                      filterText={filterText}
                    />
                  }
                  subHeaderAlign="right"
                  theme={themeContext}
                />
                <div className="row justify-content-between m-4">
                  <div className="col-auto">
                    <Button onClick={() => prevStep()}>Kembali</Button>
                  </div>
                  <div className="col-auto">
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => nextStep()}
                      disabled={isNextDisable}
                    >
                      Selanjutnya
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Fragment>
  );
};
export default StepTiga;
